<template>
  <div class="sign-in-update">
    <ModalTitle v-if="messages">
      <span v-if="response?.isShowClubCardTitle"> {{ messages.createClubCard }} </span>
      <span v-else> {{ messages.updatePhoneTitle }} </span>
    </ModalTitle>
    <SignInPhoneUpdate :messages="messages" :response="response" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ModalTitle from '@components/modals/Parts/ModalTitle.vue';
import SignInPhoneUpdate from '@components/Cabinet/Entry/SignInPhoneUpdate/SignInPhoneUpdate.vue';

export default {
  name: 'SignInUpdate',
  components: {
    SignInPhoneUpdate,
    ModalTitle,
  },
  props: ['response'],
  computed: {
    ...mapState({
      auth: ({ personal }) => personal.data?.routes?.auth.data,
      messages: ({ results }) => results.messages.entry,
    }),
  },
  methods: {
    // ...mapActions({
    //     getData: 'personal/getData',
    // })
  },

  // beforeMount() {
  //     const { action, api } = this.auth;
  //     this.getData({
  //         action,
  //         api,
  //     });
  // }
};
</script>

<style lang="scss" scoped>
.sign-in-update {
}
</style>
